if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      cartUpdateUnsubscriber = undefined;
      onVariantChangeUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      mediaList = [];
      paymentTermsResizeObserver = undefined;
      paymentTermsMutationObserver = undefined;
      paymentTermsVisibilityTimeouts = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');

        //this.input = this.querySelector('.quantity__input');
        //this.currentVariant = this.querySelector('.product-variant-id');
        //this.variantSelects = this.querySelector('variant-radios');
        //this.submitButton = this.querySelector('[type="submit"]');
      }

      //cartUpdateUnsubscriber = undefined;
      //variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        
        this.initQuantityHandlers();
        this.initPaymentTermsVisibility();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        this.applyVariantColorMediaFilter();

        /*if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });*/
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      initPaymentTermsVisibility() {
        this.paymentTermsWrapper = this.querySelector('.wbspayinstall');
        this.paymentTermsElement = this.paymentTermsWrapper?.querySelector('shopify-payment-terms');

        if (!this.paymentTermsWrapper || !this.paymentTermsElement) return;

        this.updatePaymentTermsVisibility();
        this.paymentTermsMutationObserver?.disconnect();
        this.paymentTermsResizeObserver?.disconnect();

        this.paymentTermsMutationObserver = new MutationObserver(() => this.updatePaymentTermsVisibility());
        this.paymentTermsMutationObserver.observe(this.paymentTermsElement, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
        });

        if (typeof ResizeObserver !== 'undefined') {
          this.paymentTermsResizeObserver = new ResizeObserver(() => this.updatePaymentTermsVisibility());
          this.paymentTermsResizeObserver.observe(this.paymentTermsElement);
        }

        this.schedulePaymentTermsVisibilityChecks();
      }

      schedulePaymentTermsVisibilityChecks() {
        if (!this.paymentTermsElement || !this.paymentTermsWrapper) return;

        this.paymentTermsVisibilityTimeouts.forEach((timeoutId) => window.clearTimeout(timeoutId));
        this.paymentTermsVisibilityTimeouts = [];

        this.updatePaymentTermsVisibility();

        [150, 500, 1200].forEach((delay) => {
          const timeoutId = window.setTimeout(() => this.updatePaymentTermsVisibility(), delay);
          this.paymentTermsVisibilityTimeouts.push(timeoutId);
        });
      }

      updatePaymentTermsVisibility() {
        if (!this.paymentTermsElement || !this.paymentTermsWrapper) return;

        const lightDomText = (this.paymentTermsElement.textContent || this.paymentTermsElement.innerText || '').trim();
        const shadowDomText = this.paymentTermsElement.shadowRoot
          ? (this.paymentTermsElement.shadowRoot.textContent || '').trim()
          : '';
        const renderedHeight = Math.max(
          this.paymentTermsElement.offsetHeight || 0,
          this.paymentTermsElement.scrollHeight || 0,
          this.paymentTermsElement.getBoundingClientRect?.().height || 0
        );
        const hasPaymentCopy = Boolean(lightDomText || shadowDomText || renderedHeight > 10);

        this.paymentTermsWrapper.classList.toggle('is-visible', hasPaymentCopy);
      }

      teardownPaymentTermsVisibility() {
        this.paymentTermsMutationObserver?.disconnect();
        this.paymentTermsResizeObserver?.disconnect();
        this.paymentTermsVisibilityTimeouts.forEach((timeoutId) => window.clearTimeout(timeoutId));
        this.paymentTermsVisibilityTimeouts = [];
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        this.teardownPaymentTermsVisibility();

        /*if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }*/
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            //document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name !== 'AbortError') {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML || productInfoNode.querySelector('variant-hover [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        url = url.split('?')[0];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

     updateOptionValues(html) {
  // Keep pills fixed: DO NOT swap/transition the whole variant-selects element
  // Just update the selected variant JSON inside it so other logic stays correct.
  const source =
    html.querySelector('variant-selects [data-selected-variant]')?.innerHTML ||
    html.querySelector('variant-hover [data-selected-variant]')?.innerHTML;

  const destination =
    this.variantSelectors?.querySelector('[data-selected-variant]') ||
    this.querySelector('variant-hover [data-selected-variant]');

  if (source && destination) destination.innerHTML = source;
}


      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          this.schedulePaymentTermsVisibilityChecks();

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Stock', ({ classList }) => classList.contains('hidden'));
          
          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          if (this.dataset.layout == "card") {
            const mediaDestination = this.querySelector(`#webipro-${this.dataset.section}-${this.dataset.productId}`); //?.querySelector('.product__media-item');
            const mediaSource = html.getElementById(`webipro-${this.dataset.originalSection}-${this.dataset.productId}`); //?.querySelector('.product__media-item');
            if (mediaDestination && mediaSource) {
              mediaDestination.innerHTML = mediaSource.innerHTML;
            }

            const priceDestination = this.querySelector(`#price-${this.dataset.section}-${this.dataset.productId}`);
            const priceSource = html.getElementById(`price-${this.dataset.originalSection}-${this.dataset.productId}`);
            if (mediaDestination && mediaSource) {
              priceDestination.innerHTML = priceSource.innerHTML;
            }

            const badgeDestination = this.querySelector(`#Badge-${this.dataset.section}-${this.dataset.productId}`);
            const badgeSource = html.getElementById(`Badge-${this.dataset.originalSection}-${this.dataset.productId}`);
            if (badgeDestination && badgeSource) {
              badgeDestination.innerHTML = badgeSource.innerHTML;
            } else {
              badgeDestination.innerHTML = "";
            }

            this.productForm?.toggleSubmitButton(
              html.getElementById(`product-form-${this.dataset.originalSection}-${this.dataset.productId}-submit`)?.hasAttribute('disabled') ?? true,
              window.variantStrings.soldOut
            );
          } else {
            this.productForm?.toggleSubmitButton(
              html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
              window.variantStrings.soldOut
            );
          }
          
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-${this.dataset.productId}, #product-form-installment-${this.dataset.section}-${this.dataset.productId}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        /*this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );*/

        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (shareButton) {
          shareButton.updateUrl(`${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`);
        }

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Stock', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      normalizeMediaFilterValue(value) {
        return (value || '')
          .toString()
          .toLowerCase()
          .replace(/%20/g, ' ')
          .replace(/[_+]+/g, ' ')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      isSharedVariantMediaKey(mediaKey) {
        return [
          'all-variants',
          'allvariants',
          'all-variant',
          'allvariant',
          'all-colours',
          'allcolours',
          'all-colors',
          'allcolors',
          'all-colour',
          'allcolour',
          'all-color',
          'allcolor',
          'colour-options',
          'colouroptions',
          'color-options',
          'coloroptions',
          'all-finishes',
          'allfinishes',
        ].some((token) => mediaKey.includes(token));
      }

      getSelectedColorOptionValue() {
        const selectors = this.variantSelectors || this.querySelector('variant-hover');
        if (!selectors) return '';

        const controls = Array.from(selectors.querySelectorAll('input[type="radio"]:checked, select'));
        const colorControl = controls.find((control) => {
          const optionName = (control.name || '').replace(/^options\[/, '').replace(/\]$/, '');
          const groupLabel = control.closest('.product-form__input')?.querySelector('.form__label')?.textContent || '';
          return /colou?r/i.test(optionName) || /colou?r/i.test(groupLabel);
        });

        return colorControl?.value || '';
      }

      updateFilteredSlider(sliderComponent) {
        if (!sliderComponent?.slider) return;

        sliderComponent.sliderItems = sliderComponent.querySelectorAll('[id^="Slide-"]');
        const visibleItems = Array.from(sliderComponent.sliderItems).filter((item) => !item.hidden);

        if (visibleItems.length <= 1) {
          sliderComponent.sliderItemsToShow = visibleItems;
          sliderComponent.currentPage = 1;
          sliderComponent.totalPages = Math.max(visibleItems.length, 1);
          if (sliderComponent.currentPageElement) sliderComponent.currentPageElement.textContent = '1';
          if (sliderComponent.pageTotalElement) sliderComponent.pageTotalElement.textContent = String(sliderComponent.totalPages);
          sliderComponent.prevButton?.setAttribute('disabled', 'disabled');
          sliderComponent.nextButton?.setAttribute('disabled', 'disabled');
          return;
        }

        sliderComponent.resetPages?.();
      }

      applyVariantColorMediaFilter() {
        const galleries = Array.from(this.querySelectorAll('media-gallery[data-variant-color-media-filter="true"]'));
        if (!galleries.length) return null;

        const selectedColorKey = this.normalizeMediaFilterValue(this.getSelectedColorOptionValue());
        const selectedColorKeyCompact = selectedColorKey.replace(/-/g, '');
        let firstVisibleMediaId = null;

        galleries.forEach((gallery) => {
          const mediaLists = Array.from(gallery.querySelectorAll('ul.product__media-list, ul.thumbnail-list'));

          mediaLists.forEach((mediaList) => {
            const mediaItems = Array.from(mediaList.querySelectorAll('li[data-media-id], li[data-target]'));
            if (!selectedColorKey) {
              mediaItems.forEach((item) => {
                item.hidden = false;
              });
              this.updateFilteredSlider(mediaList.closest('slider-component'));
              return;
            }

            const colorItems = [];
            const sharedItems = [];

            mediaItems.forEach((item) => {
              item.classList.remove('product__media-item--variant', 'thumbnail-list_item--variant');
              const mediaKey = this.normalizeMediaFilterValue(item.dataset.mediaFilterKey);
              const mediaKeyCompact = mediaKey.replace(/-/g, '');
              const isShared = this.isSharedVariantMediaKey(mediaKey);

              if (isShared) {
                sharedItems.push(item);
              } else if (mediaKey.includes(selectedColorKey) || mediaKeyCompact.includes(selectedColorKeyCompact)) {
                colorItems.push(item);
              }
            });

            const shouldFilter = colorItems.length > 0;
            const visibleItems = shouldFilter ? [...colorItems, ...sharedItems] : mediaItems;
            const visibleItemSet = new Set(visibleItems);

            mediaItems.forEach((item) => {
              item.hidden = shouldFilter && !visibleItemSet.has(item);
            });
            visibleItems.forEach((item, index) => {
              mediaList.appendChild(item);
              if (item.dataset.mediaPosition) item.dataset.mediaPosition = String(index + 1);
            });

            if (mediaList.classList.contains('product__media-list') && visibleItems[0]) {
              mediaItems.forEach((item) => item.classList.remove('is-active'));
              visibleItems[0].classList.add('is-active');
            }

            if (mediaList.classList.contains('thumbnail-list') && visibleItems[0]) {
              mediaItems.forEach((item) => item.querySelector('button')?.removeAttribute('aria-current'));
              visibleItems[0].querySelector('button')?.setAttribute('aria-current', true);
            }

            if (!firstVisibleMediaId && shouldFilter && mediaList.classList.contains('product__media-list')) {
              firstVisibleMediaId = visibleItems[0]?.dataset.mediaId || null;
            }

            this.updateFilteredSlider(mediaList.closest('slider-component'));
          });
        });

        return firstVisibleMediaId;
      }

      updateMedia(html, variantFeaturedMediaId) {
        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // update media attr for quick add
        const sectionId = this.dataset.section;
        if (sectionId.includes('quickadd-')) {
          this.querySelector('media-gallery')?.querySelectorAll('li[data-media-id]').forEach((el) => {
            const newValue = `quickadd-${el.dataset.mediaId}`;
            el.dataset.mediaId = newValue;
          });
        }

        const mediaGallery = this.querySelector(`media-gallery`);
        const filterActiveMediaId = this.applyVariantColorMediaFilter();
        const hasVariantColorMediaFilter = mediaGallery?.dataset.variantColorMediaFilter === 'true';
        const activeMediaId = hasVariantColorMediaFilter
          ? filterActiveMediaId || (variantFeaturedMediaId ? `${this.dataset.section}-${variantFeaturedMediaId}` : null)
          : variantFeaturedMediaId ? `${this.dataset.section}-${variantFeaturedMediaId}` : filterActiveMediaId;

        // set featured media as active in the media gallery
        if (activeMediaId) {
          mediaGallery?.setActiveMedia?.(
            activeMediaId,
            !hasVariantColorMediaFilter
          );
        }

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;
        this.quantityInput.max = max;
        this.quantityInput.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading-overlay')?.classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay')?.classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm?.querySelector(selector);
          const updated = quantityFormUpdated?.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
